var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../static/img/landing/logo_white.png",
            searchImgSrc: "../../../static/img/landing/search_white.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _c("div", { staticClass: "st-MainContainer" }, [
          _c("main", { staticClass: "st-MainContents" }, [
            _c(
              "div",
              {
                staticClass: "top-Mv",
                staticStyle: { "text-align": "center" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "top-Mv_Slide swiper-container swiper-container-fade swiper-container-initialized swiper-container-horizontal"
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "swiper-pagination-bullet swiper-pagination-bullet-active",
                            attrs: {
                              tabindex: "0",
                              role: "button",
                              "aria-label": "Go to slide 1"
                            },
                            on: {
                              click: function($event) {
                                return _vm.swiperPagination($event, 0)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "circle" }, [
                              _c("svg", { attrs: { viewBox: "0 0 124 124" } }, [
                                _c("circle", {
                                  staticStyle: {
                                    "animation-duration": "5000ms"
                                  },
                                  attrs: { cx: "62", cy: "62", r: "60" }
                                })
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "swiper-pagination-bullet",
                            attrs: {
                              tabindex: "0",
                              role: "button",
                              "aria-label": "Go to slide 2"
                            },
                            on: {
                              click: function($event) {
                                return _vm.swiperPagination($event, 1)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "circle" }, [
                              _c("svg", { attrs: { viewBox: "0 0 124 124" } }, [
                                _c("circle", {
                                  staticStyle: {
                                    "animation-duration": "5000ms"
                                  },
                                  attrs: { cx: "62", cy: "62", r: "60" }
                                })
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "swiper-pagination-bullet",
                            attrs: {
                              tabindex: "0",
                              role: "button",
                              "aria-label": "Go to slide 3"
                            },
                            on: {
                              click: function($event) {
                                return _vm.swiperPagination($event, 2)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "circle" }, [
                              _c("svg", { attrs: { viewBox: "0 0 124 124" } }, [
                                _c("circle", {
                                  staticStyle: {
                                    "animation-duration": "5000ms"
                                  },
                                  attrs: { cx: "62", cy: "62", r: "60" }
                                })
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "swiper-pagination-bullet",
                            attrs: {
                              tabindex: "0",
                              role: "button",
                              "aria-label": "Go to slide 4"
                            },
                            on: {
                              click: function($event) {
                                return _vm.swiperPagination($event, 3)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "circle" }, [
                              _c("svg", { attrs: { viewBox: "0 0 124 124" } }, [
                                _c("circle", {
                                  staticStyle: {
                                    "animation-duration": "5000ms"
                                  },
                                  attrs: { cx: "62", cy: "62", r: "60" }
                                })
                              ])
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "swiper-notification",
                      attrs: { "aria-live": "assertive", "aria-atomic": "true" }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("section", { staticClass: "top-Product st-Grid" }, [
              _c("div", { staticClass: "st-Grid_Inner p-0" }, [
                _c(
                  "h2",
                  {
                    staticClass: "sw-Section_Header appear",
                    attrs: { "data-appear": "true" }
                  },
                  [
                    _c("span", { staticClass: "sw-Section_Header-en" }, [
                      _c(
                        "b",
                        [
                          _c(
                            "font",
                            { staticStyle: { "vertical-align": "inherit" } },
                            [
                              _c(
                                "font",
                                {
                                  staticStyle: { "vertical-align": "inherit" }
                                },
                                [_vm._v("GREETING")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "sw-Section_Header-ja" }, [
                      _c(
                        "b",
                        [
                          _c(
                            "font",
                            { staticStyle: { "vertical-align": "inherit" } },
                            [
                              _c(
                                "font",
                                {
                                  staticStyle: { "vertical-align": "inherit" }
                                },
                                [_vm._v("ご挨拶")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top-Product_RowWrap p-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Row",
                    attrs: { "data-appear": "true" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "top-Product_Image appear",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "top-Product_Image-inner3 top-Product_Image-inner"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "top-Product_Image-inner3-div" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    height: "auto",
                                    "object-fit": "scale-down"
                                  },
                                  attrs: {
                                    src: require("../../../static/img/landing/photo.png"),
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "sw-Section_Header-ja" },
                                  [
                                    _c(
                                      "b",
                                      [
                                        _c(
                                          "font",
                                          {
                                            staticStyle: {
                                              "vertical-align": "inherit"
                                            }
                                          },
                                          [
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "font",
                                              {
                                                staticStyle: {
                                                  color: "blue",
                                                  "text-align": "center"
                                                }
                                              },
                                              [_vm._v("代表取締役 小山 雄")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "top-Product_Body",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c("div", { staticClass: "top-Product_Body-inner" }, [
                          _c(
                            "p",
                            { staticClass: "top-Product_Body-text" },
                            [
                              _c(
                                "font",
                                {
                                  staticStyle: { "vertical-align": "inherit" }
                                },
                                [
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "組織には“全体最適“という考え方がありますが、ひとつのチーム、班、係、課、部、会社にとどまらず、"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "この社会全体が等しく発展し、そこに貢献することが私の夢です。"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("font", {
                                    staticStyle: { "vertical-align": "inherit" }
                                  }),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("font", {
                                    staticStyle: { "vertical-align": "inherit" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._m(1)
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "st-Grid_Inner p-0",
                    staticStyle: { "margin-top": "150px" }
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "sw-Section_Header",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c("span", { staticClass: "sw-Section_Header-en" }, [
                          _c(
                            "b",
                            [
                              _c(
                                "font",
                                {
                                  staticStyle: { "vertical-align": "inherit" }
                                },
                                [
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [_vm._v("Management Philosophy")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sw-Section_Header-ja" }, [
                          _c(
                            "b",
                            [
                              _c(
                                "font",
                                {
                                  staticStyle: { "vertical-align": "inherit" }
                                },
                                [
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [_vm._v("経営理念")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Row",
                    staticStyle: { "margin-top": "150px" },
                    attrs: { "data-appear": "true" }
                  },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "top-Product_Body",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c("div", { staticClass: "top-Product_Body-inner" }, [
                          _c(
                            "p",
                            { staticClass: "top-Product_Body-text" },
                            [
                              _c(
                                "font",
                                {
                                  staticStyle: { "vertical-align": "inherit" }
                                },
                                [
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "“三方良し”という商売精神ずっと通用する。そして、"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "社員一人一人の発想力と行動力を発揮し、社会のために楽しく働こう、"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "これによって自分の人生を豊かに有意義に作り上げましょう！"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "世界トップクラスを誇るクラス日本の技術力と海外の人材、資源を活用"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "し、お客様と共に発展し、得た利益を社会に還元する。"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("font", {
                                    staticStyle: { "vertical-align": "inherit" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._m(4)
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _vm._m(6)
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "swiper-slide top-Mv_Slide-item",
          attrs: {
            "data-swiper-autoplay": "5000",
            "data-swiper-slide-index": "0"
          }
        },
        [
          _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _c("div", { staticClass: "top-Mv_Slide-image" }, [
              _c("div", { staticClass: "top-Mv_Slide-image-sp" }, [
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                  staticStyle: {
                    background:
                      "url(../../../static/img/landing/turnimg03.png) 50%/cover no-repeat"
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                  staticStyle: {
                    background:
                      "url(../../../static/img/landing/turnimg03.png) 50%/cover no-repeat"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top-Mv_Slide-image-pc" }, [
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                  staticStyle: {
                    background:
                      "url(../../../static/img/landing/turnimg03.png) 50%/cover no-repeat"
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                  staticStyle: {
                    background:
                      "url(../../../static/img/landing/turnimg03.png) 50%/cover no-repeat"
                  }
                })
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "swiper-slide top-Mv_Slide-item",
          attrs: {
            "data-swiper-autoplay": "5000",
            "data-swiper-slide-index": "1"
          }
        },
        [
          _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _c("div", { staticClass: "top-Mv_Slide-image" }, [
              _c("div", { staticClass: "top-Mv_Slide-image-sp" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                    staticStyle: {
                      background:
                        "url(../../../static/img/landing/turnimg01.png) 50%/cover no-repeat"
                    }
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "pr-6 pl-6",
                          staticStyle: {
                            "padding-top": "260px",
                            color: "#FFFFFF",
                            "font-size": "30px"
                          }
                        },
                        [_vm._v("五軸マシンニングでの精密部品量産加工")]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                    staticStyle: {
                      background:
                        "url(../../../static/img/landing/turnimg01.png) 50%/cover no-repeat"
                    }
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "pr-6 pl-6",
                          staticStyle: {
                            "padding-top": "260px",
                            color: "#FFFFFF",
                            "font-size": "30px"
                          }
                        },
                        [_vm._v("五軸マシンニングでの精密部品量産加工")]
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top-Mv_Slide-image-pc" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                    staticStyle: {
                      background:
                        "url(../../../static/img/landing/turnimg01.png) 50%/cover no-repeat"
                    }
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "pr-6 pl-6",
                          staticStyle: {
                            "padding-top": "260px",
                            color: "#FFFFFF",
                            "font-size": "30px"
                          }
                        },
                        [_vm._v("五軸マシンニングでの精密部品量産加工")]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                    staticStyle: {
                      background:
                        "url(../../../static/img/landing/turnimg01.png) 50%/cover no-repeat"
                    }
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "pr-6 pl-6",
                          staticStyle: {
                            "padding-top": "260px",
                            color: "#FFFFFF",
                            "font-size": "30px"
                          }
                        },
                        [_vm._v("五軸マシンニングでの精密部品量産加工")]
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "swiper-slide top-Mv_Slide-item",
          attrs: {
            "data-swiper-autoplay": "5000",
            "data-swiper-slide-index": "2"
          }
        },
        [
          _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _c("div", { staticClass: "top-Mv_Slide-image" }, [
              _c("div", { staticClass: "top-Mv_Slide-image-sp" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                    staticStyle: {
                      background:
                        "url(../../../static/img/landing/turnimg02.png) 50%/cover no-repeat"
                    }
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "pr-6 pl-6",
                          staticStyle: {
                            "padding-top": "260px",
                            color: "#FFFFFF",
                            "font-size": "30px"
                          }
                        },
                        [_vm._v("自動省力化機械の設計、製造")]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                    staticStyle: {
                      background:
                        "url(../../../static/img/landing/turnimg02.png) 50%/cover no-repeat"
                    }
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "pr-6 pl-6",
                          staticStyle: {
                            "padding-top": "260px",
                            color: "#FFFFFF",
                            "font-size": "30px"
                          }
                        },
                        [_vm._v("自動省力化機械の設計、製造")]
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top-Mv_Slide-image-pc" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                    staticStyle: {
                      background:
                        "url(../../../static/img/landing/turnimg02.png) 50%/cover no-repeat"
                    }
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "pr-6 pl-6",
                          staticStyle: {
                            "padding-top": "260px",
                            color: "#FFFFFF",
                            "font-size": "30px"
                          }
                        },
                        [_vm._v("自動省力化機械の設計、製造")]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                    staticStyle: {
                      background:
                        "url(../../../static/img/landing/turnimg02.png) 50%/cover no-repeat"
                    }
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "pr-6 pl-6",
                          staticStyle: {
                            "padding-top": "260px",
                            color: "#FFFFFF",
                            "font-size": "30px"
                          }
                        },
                        [_vm._v("自動省力化機械の設計、製造")]
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "swiper-slide top-Mv_Slide-item",
          attrs: {
            "data-swiper-autoplay": "5000",
            "data-swiper-slide-index": "3"
          }
        },
        [
          _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _c("div", { staticClass: "top-Mv_Slide-image" }, [
              _c("div", { staticClass: "top-Mv_Slide-image-sp" }, [
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                  staticStyle: {
                    background:
                      "url(../../../static/img/landing/turnimg04.png) 50%/cover no-repeat"
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                  staticStyle: {
                    background:
                      "url(../../../static/img/landing/turnimg04.png) 50%/cover no-repeat"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top-Mv_Slide-image-pc" }, [
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                  staticStyle: {
                    background:
                      "url(../../../static/img/landing/turnimg04.png) 50%/cover no-repeat"
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                  staticStyle: {
                    background:
                      "url(../../../static/img/landing/turnimg04.png) 50%/cover no-repeat"
                  }
                })
              ])
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sw-ButtonCircle" }, [
      _c("div", [
        _c("i", {
          staticClass: "icf el-icon-arrow-right",
          staticStyle: { "font-size": "25px", bottom: "15px" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "top-Product_ColumnWrap pl-3 pr-3 p-md-0" },
      [
        _c(
          "div",
          {
            staticClass: "top-Product_Column",
            attrs: { "data-appear": "false" }
          },
          [
            _c(
              "div",
              {
                staticClass: "top-Product_Image p-0",
                attrs: { "data-appear": "false" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Image-inner",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "260px",
                        "background-color": "white",
                        "object-fit": "cover"
                      },
                      attrs: {
                        src: require("../../../static/img/landing/main1.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top-Product_Column ml-md-3",
            attrs: { "data-appear": "false" }
          },
          [
            _c(
              "div",
              {
                staticClass: "top-Product_Image p-0",
                attrs: { "data-appear": "false" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Image-inner",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "260px",
                        "background-color": "white",
                        "object-fit": "cover"
                      },
                      attrs: {
                        src: require("../../../static/img/landing/main2.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top-Product_Column ml-md-3",
            attrs: { "data-appear": "false" }
          },
          [
            _c(
              "div",
              {
                staticClass: "top-Product_Image p-0",
                attrs: { "data-appear": "false" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Image-inner",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "260px",
                        "background-color": "white",
                        "object-fit": "cover"
                      },
                      attrs: {
                        src: require("../../../static/img/landing/main3.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top-Product_Column ml-md-3",
            attrs: { "data-appear": "false" }
          },
          [
            _c(
              "div",
              {
                staticClass: "top-Product_Image p-0",
                attrs: { "data-appear": "false" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Image-inner",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "260px",
                        "background-color": "white",
                        "object-fit": "cover"
                      },
                      attrs: {
                        src: require("../../../static/img/landing/main4.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "top-Product_Image", attrs: { "data-appear": "true" } },
      [
        _c(
          "div",
          { staticClass: "top-Product_Image-inner top-Product_Image-inner-2 " },
          [
            _c("img", {
              staticStyle: {
                "background-color": "white",
                "object-fit": "cover"
              },
              attrs: {
                src: require("../../../static/img/landing/picture.png"),
                alt: ""
              }
            })
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sw-ButtonCircle" }, [
      _c("div", [
        _c("i", {
          staticClass: "icf el-icon-arrow-right",
          staticStyle: { "font-size": "25px", bottom: "15px" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "top-Product_ColumnWrap pl-3 pr-3 p-md-1" },
      [
        _c(
          "div",
          {
            staticClass: "top-Product_Column",
            attrs: { "data-appear": "false" }
          },
          [
            _c(
              "div",
              {
                staticClass: "top-Product_Image appear p-0",
                attrs: { "data-appear": "false" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Image-inner",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "260px",
                        "background-color": "white",
                        "object-fit": "cover"
                      },
                      attrs: {
                        src: require("../../../static/img/landing/product01.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top-Product_Column ml-md-3",
            attrs: { "data-appear": "false" }
          },
          [
            _c(
              "div",
              {
                staticClass: "top-Product_Image appear p-0",
                attrs: { "data-appear": "false" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Image-inner",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "260px",
                        "background-color": "white",
                        "object-fit": "cover"
                      },
                      attrs: {
                        src: require("../../../static/img/landing/product02.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top-Product_Column ml-md-3",
            attrs: { "data-appear": "false" }
          },
          [
            _c(
              "div",
              {
                staticClass: "top-Product_Image appear p-0",
                attrs: { "data-appear": "false" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Image-inner",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "260px",
                        "background-color": "white",
                        "object-fit": "cover"
                      },
                      attrs: {
                        src: require("../../../static/img/landing/product03.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "top-Product_ColumnWrap pl-3 pr-3 p-md-1" },
      [
        _c(
          "div",
          {
            staticClass: "top-Product_Column",
            attrs: { "data-appear": "false" }
          },
          [
            _c(
              "div",
              {
                staticClass: "top-Product_Image appear p-0",
                attrs: { "data-appear": "false" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Image-inner",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "260px",
                        "background-color": "white",
                        "object-fit": "cover"
                      },
                      attrs: {
                        src: require("../../../static/img/landing/product04.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top-Product_Column ml-md-3",
            attrs: { "data-appear": "false" }
          },
          [
            _c(
              "div",
              {
                staticClass: "top-Product_Image appear p-0",
                attrs: { "data-appear": "false" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Image-inner",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "260px",
                        "background-color": "white",
                        "object-fit": "cover"
                      },
                      attrs: {
                        src: require("../../../static/img/landing/product05.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top-Product_Column ml-md-3",
            attrs: { "data-appear": "false" }
          },
          [
            _c(
              "div",
              {
                staticClass: "top-Product_Image appear p-0",
                attrs: { "data-appear": "false" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "top-Product_Image-inner",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        height: "260px",
                        "background-color": "white",
                        "object-fit": "cover"
                      },
                      attrs: {
                        src: require("../../../static/img/landing/product06.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6800e0ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6800e0ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/landing.vue
// module id = null
// module chunks = 